import React from 'react';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import PDFRenderer from './PDFRenderer';
import UnsupportedFilePreview from './UnsupportedFilePreview';

const supportedFileTypes = DocViewerRenderers.map(renderer => renderer.fileTypes).flat();

interface IPreviewFileProps {
    uri?: string;
    type?: string;
    minHeight?: number;
}

const PreviewFile = ({ uri, type, minHeight }: IPreviewFileProps) => {
    if (!uri || !type) {
        return null;
    }

    const normalizedType = type.toLowerCase();
    const isSupported = supportedFileTypes.includes(normalizedType);

    if (!isSupported) {
        return <UnsupportedFilePreview fileType={type} />;
    }

    const renderers = normalizedType === 'pdf' || normalizedType === 'application/pdf' ? [PDFRenderer] : DocViewerRenderers;
    
    return (
        <div className="d-flex w-100 h-50 flex-wrap">
            <DocViewer
                className="w-100 h-100"
                style={minHeight ? { minHeight: `${minHeight}px` } : undefined}
                config={{
                    header: {
                        disableHeader: true,
                        disableFileName: true,
                        retainURLParams: false,
                    },
                }}
                pluginRenderers={renderers}
                documents={[
                    {
                        uri,
                        fileType: type,
                    },
                ]}
            />
        </div>
    );
};

export default React.memo(PreviewFile);
